<template>
  <div class="d-flex flex-column">
    <div class="stopover mt-3">
      <a @click="open = !open" class="toggle fit-content link-light">
        {{ text }} <i class="arrow mx-1" :class="{ up: open, down: !open }"></i>
      </a>
    </div>
    <transition name="open">
      <div v-if="open">
        <div class="overflow-hidden">
          <div class="d-flex flex-column">
            <div
              class="stopover my-2"
              v-for="stopover in stopovers.slice(1, -1)"
              :key="stopover.stop.id"
            >
              <div class="d-contents">
                <div class="time">
                  <div class="d-flex gap-1 flex-row-reverse">
                    <outdated-info
                      :real="dayjs(stopover.arrival).tz('Europe/Berlin').format('HH:mm')"
                      :planned="
                        stopover.plannedArrival
                          ? dayjs(stopover.plannedArrival).tz('Europe/Berlin').format('HH:mm')
                          : undefined
                      "
                      :cancelled="stopover.cancelled"
                      :inline="true"
                    >
                    </outdated-info>
                  </div>
                  <div class="d-flex gap-1 flex-row-reverse">
                    <outdated-info
                      :real="dayjs(stopover.departure).tz('Europe/Berlin').format('HH:mm')"
                      :planned="
                        stopover.plannedDeparture
                          ? dayjs(stopover.plannedDeparture).tz('Europe/Berlin').format('HH:mm')
                          : undefined
                      "
                      :cancelled="stopover.cancelled"
                      :inline="true"
                    >
                    </outdated-info>
                  </div>
                </div>
                <i class="fancy-line d-block m-auto icon icon-record-fill stopover-marker"></i>
                <del class="station" v-if="stopover.cancelled">{{ stopover.stop.name }}</del>
                <div class="station" v-else>{{ stopover.stop.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { type Stopover } from '~/types/fptfTypes'
import dayjs from 'dayjs'
import OutdatedInfo from '../OutdatedInfo.vue'
import { ref, computed } from 'vue'

const props = defineProps<{
  stopovers: Stopover[]
}>()

const open = ref(false)
const text = computed(() =>
  props.stopovers.length === 3 ? '1 Zwischenhalt' : `${props.stopovers.length - 2} Zwischenhalte`
)
</script>

<style lang="scss">
.stopover-marker {
  z-index: 3;
  font-size: 12px;
}

.arrow {
  border: solid $body-color-dark;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  transition: all 0.3s;
}

// .right {
//   transform: translateX(-20%) rotate(-45deg);
// }

// .left {
//   transform: translateX(20%) rotate(135deg);
// }

.up {
  transform: translateY(20%) rotate(-135deg);
}

.down {
  transform: translateY(-20%) rotate(45deg);
}

.stopover {
  display: inline-grid;
  gap: 5px;
  grid-template-columns: $time_col_width $fancy_line_width 1fr;
  grid-template-areas: 'times fancy-line station';

  .toggle {
    grid-area: station;
    cursor: pointer;
  }

  .time {
    grid-area: times;
  }

  .station {
    grid-area: station;
  }

  .fancy-line {
    grid-area: fancy-line;
  }
}
</style>
